import { render, staticRenderFns } from "./contactArrived.vue?vue&type=template&id=605c2a24&"
import script from "./contactArrived.vue?vue&type=script&lang=js&"
export * from "./contactArrived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports